var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_site",
    transform: "translate(0.367 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    width: 28,
    height: 28,
    transform: "translate(-0.367 -2)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "iconography",
    d: "M24.892,22.954V19.932a2.35,2.35,0,0,0-2.347-2.347H14.968V14.839h5.053a1.151,1.151,0,0,0,1.151-1.151V8.061A1.151,1.151,0,0,0,20.021,6.91H7.613A1.151,1.151,0,0,0,6.462,8.061v5.627A1.151,1.151,0,0,0,7.613,14.84h5.052v2.746H5.088a2.35,2.35,0,0,0-2.347,2.347v3.022a3.893,3.893,0,1,0,2.3,0V19.932a.044.044,0,0,1,.044-.044h7.577v3.066a3.893,3.893,0,1,0,2.3,0V19.888h7.577a.044.044,0,0,1,.044.044v3.022a3.893,3.893,0,1,0,2.3,0ZM8.764,9.213h10.1v3.324H8.764ZM3.893,28.262a1.59,1.59,0,1,1,1.59-1.59A1.592,1.592,0,0,1,3.893,28.262Zm9.924,0a1.59,1.59,0,1,1,1.59-1.589A1.592,1.592,0,0,1,13.817,28.262Zm9.924,0a1.59,1.59,0,1,1,1.59-1.589A1.591,1.591,0,0,1,23.741,28.262Z",
    transform: "translate(0 -6.91)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSite);
export default __webpack_public_path__ + "static/media/ico-site.ce4982c2d03ea49999a2ac68977d0b2b.svg";
export { ForwardRef as ReactComponent };